module.exports = __webpack_public_path__ + "img/1.f9364cf4.png";